import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

actionStyles.printButton = {
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-radius: 25px;
    `,
    variant: "primary",
}

actionStyles.scheduleButton = {
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-radius: 25px;
    `,
    variant: "primary",
}

actionStyles.editButton = {
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-radius: 25px;
    `,
    variant: "primary",
}

actionStyles.shareButton = {
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-radius: 25px;
    `,
    variant: "primary",
}

actionStyles.removeSelectedButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-radius: 25px;
    `,
    variant: "primary",
}

actionStyles.addListButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 15px;
        border-radius: 25px;
    `,
}